import { donationsApi } from '../api/donationsApi'
import type { DonationUpdateInput } from '../types/donation'

export const updateDonation = async (donation: DonationUpdateInput) => {
  try {
    const { data } = await donationsApi.updateDonation(donation)
    return data
  } catch (error) {
    console.error(`Error updating donations: `, error)
    throw error
  }
}
